import { useMatches } from 'react-router';

import { I18nLocale, isI18nLocale } from '#/i18n/types/I18nLocale';

export type LoaderDataWithOverrideLocale = {
  overrideLocale: I18nLocale | null;
} & Record<string, unknown>;

export function useMatchesOverrideLocale(): {
  overrideLocale: I18nLocale | null;
} {
  const matches = useMatches();

  for (let i = matches.length - 1; i > 0; i--) {
    const match = matches[i];

    if (
      match.loaderData &&
      typeof match.loaderData === 'object' &&
      'overrideLocale' in match.loaderData &&
      typeof match.loaderData.overrideLocale === 'string' &&
      isI18nLocale(match.loaderData.overrideLocale)
    ) {
      return { overrideLocale: match.loaderData.overrideLocale };
    }
  }

  return { overrideLocale: null };
}
